'use strict';

var cov_2qdmpjhsdb = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/recurrentDetails/recurrentDetails.js',
        hash = 'b901d412ddd659b330178a35c568659a3721d268',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/recurrentDetails/recurrentDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 48
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 0
                },
                end: {
                    line: 16,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 31
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecurrentDetailsController = function RecurrentDetailsController(ProjectsTable) {
    _classCallCheck(this, RecurrentDetailsController);

    cov_2qdmpjhsdb.f[0]++;
    cov_2qdmpjhsdb.s[0]++;

    this.projects = ProjectsTable.$search();
};

cov_2qdmpjhsdb.s[1]++;


angular.module('app').component('recurrentDetails', {
    templateUrl: 'app/components/recurrentDetails/recurrentDetails.html',
    controller: RecurrentDetailsController,
    bindings: {
        recurrent: '<'
    }
});